import React, { useState, useRef, useCallback } from 'react';
import classnames from 'classnames';
import { debounce } from 'shared/utils';
import styles from './styles.mod.scss';

export default function QuantityPicker({
  defaultValue,
  min = 0,
  max = 999,
  maxLength = 3,
  disabled,
  onChange,
  ariaLabel,
  className
}) {
  const [value, setValue] = useState(defaultValue);
  const inputRef = useRef();

  function isValid(n) {
    return Number(n) >= Number(min) && Number(n) <= Number(max);
  }

  const debouncedBlur = useCallback(
    debounce(() => {
      if (inputRef.current && inputRef.current === document.activeElement) {
        inputRef.current.blur();
      }
    }, 2000)
  );

  function updateInternalValue(e) {
    const string = String(e.target.value);
    if (string.length <= maxLength) setValue(string);
    if (string.length > 0) debouncedBlur();
  }

  function updateValue() {
    if (Number(value) !== defaultValue) {
      if (isValid(value)) {
        return onChange(Number(value));
      } else {
        setValue(defaultValue);
      }
    }
  }

  return (
    <input
      aria-label={ariaLabel}
      className={classnames(styles.input, styles.qtyPicker, className)}
      min={min}
      max={max}
      maxLength={maxLength}
      type="number"
      value={value}
      onChange={updateInternalValue}
      onBlur={updateValue}
      disabled={disabled}
      ref={inputRef}
    />
  );
}
